import React, { createContext, ReactNode, useContext, useState } from 'react';

interface FormStateContextValue {
  busyButtonId: string | null;
  setBusyButtonId: (buttonId: string | null) => void;
}

const FormStateContext = createContext<FormStateContextValue | undefined>(undefined);

interface FormStateProviderProps {
  children: ReactNode;
}

export const FormStateProvider: React.FC<FormStateProviderProps> = ({ children }) => {
  const [busyButtonId, setBusyButtonId] = useState<string | null>(null);

  return (
    <FormStateContext.Provider value={{ busyButtonId, setBusyButtonId }}>
      {children}
    </FormStateContext.Provider>
  );
};

export const useFormState = (): FormStateContextValue => {
  const context = useContext(FormStateContext);
  if (!context) {
    throw new Error('useFormState must be used within an FormStateProvider');
  }
  return context;
};
